var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177.72 177.72",
    style: {
      enableBackground: "new 0 0 177.72 177.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    cx: 88.86,
    cy: 41.01,
    r: 41.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M88.86,109.37c-28.23,0-53.92,10.29-70.33,18.8C7.18,134.05,0,145.77,0,158.65v6.25 c0,7.08,5.68,12.82,12.69,12.82h152.33c7.01,0,12.69-5.74,12.69-12.82v-6.25c0-12.89-7.18-24.6-18.53-30.49 C142.78,119.66,117.09,109.37,88.86,109.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPax);
export default __webpack_public_path__ + "static/media/icon_pax.31da4ef32e506c3a27d43628c14ae7ab.svg";
export { ForwardRef as ReactComponent };